import React from 'react';
import { HeroesList } from '../heroes/HeroesList';

export const MarvelScreen = () => {
  return <HeroesList publisher="Marvel Comics" />;
};
